import {
  ILeaveRecord,
  ILeaveStatsResponse,
} from '../../apis/staff/staffLeaves.interfaces';

export const mockStaffLeaveStats: ILeaveStatsResponse = {
  stats: [
    { leaveTypeId: 'lt-1', leaveTypeName: 'Public Holiday', leaveTypeCode: 'public', available: 10, taken: 0 },
    { leaveTypeId: 'lt-2', leaveTypeName: 'Optional Vacation', leaveTypeCode: 'optional_vacation', available: 15, taken: 3 },
    { leaveTypeId: 'lt-3', leaveTypeName: 'Sick Leave', leaveTypeCode: 'sick', available: 12, taken: 2 },
    { leaveTypeId: 'lt-4', leaveTypeName: 'Paid Leave', leaveTypeCode: 'paid', available: 20, taken: 5 },
  ],
};

export const mockStaffLeaveList: ILeaveRecord[] = [
  {
    id: 'leave-1',
    leaveTypeId: 'lt-2',
    leaveTypeName: 'Optional Vacation',
    leaveTypeCode: 'optional_vacation',
    startDate: '2025-03-01',
    endDate: '2025-03-03',
    status: 'approved',
    reason: 'Family trip',
    appliedAt: '2025-02-20T10:00:00Z',
  },
  {
    id: 'leave-2',
    leaveTypeId: 'lt-3',
    leaveTypeName: 'Sick Leave',
    leaveTypeCode: 'sick',
    startDate: '2025-02-15',
    endDate: '2025-02-15',
    status: 'approved',
    reason: 'Fever',
    appliedAt: '2025-02-14T09:00:00Z',
  },
];
